import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import {
  updateDays,
  updateSingleDayShifts,
} from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { FormikProps } from 'formik'

export const handleBreakChange = (
  selected: any,
  formik: FormikProps<IScheduleSectionFormValues>
) => {
  const { setFieldValue, values } = formik

  setFieldValue('break', selected.value)

  const days = updateDays(values.days, {
    break: selected.value,
  })

  const single_day_shifts = updateSingleDayShifts(values.single_day_shifts, 'break', selected.value)

  setFieldValue('days', days)
  setFieldValue('single_day_shifts', single_day_shifts)
}
